import { CORE_WEEKLY_WALKTHROUGHS } from "./weekly-walkthrough-core";
import { CURRENT_WEEKLY_WALKTHROUGHS } from "./weekly-walkthrough-current";
import { PERFORMANCE_WEEKLY_WALKTHROUGHS } from "./weekly-walkthrough-performance";
import {
  WEEKLY_WALKTHROUGH_EVENTS,
  type WeeklyWalkthrough,
} from "./weekly-walkthrough-types";

export { WEEKLY_WALKTHROUGH_EVENTS };
export type { WeeklyWalkthrough };

export const WEEKLY_WALKTHROUGHS = {
  ...CORE_WEEKLY_WALKTHROUGHS,
  ...PERFORMANCE_WEEKLY_WALKTHROUGHS,
  ...CURRENT_WEEKLY_WALKTHROUGHS,
} as const satisfies Record<string, WeeklyWalkthrough>;

export type WeeklyWalkthroughId = keyof typeof WEEKLY_WALKTHROUGHS;

export function getWeeklyWalkthrough(
  value: string | null | undefined,
): WeeklyWalkthrough | null {
  if (!isWeeklyWalkthroughId(value)) return null;
  return WEEKLY_WALKTHROUGHS[value];
}

export function isWeeklyWalkthroughId(
  value: unknown,
): value is WeeklyWalkthroughId {
  return typeof value === "string" && value in WEEKLY_WALKTHROUGHS;
}
